import Swiper, {Autoplay, FreeMode} from 'swiper';
import { osHasReducedMotion } from '../util/a11y';

Swiper.use([Autoplay, FreeMode]);

export default function(element = '.js-swiper-autoplay') {

  // A11Y: Reduce Motion for Swiper Autoplay
  let autoplaySettings = osHasReducedMotion() ? {} : {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    speed: 9000,
  }

  return new Swiper(element, {
    loop: true,
    slidesPerView: 'auto',
    grabCursor: true,
    direction: 'horizontal',
    freeMode: {
      enabled: true,
      sticky: false,
    },
    ...autoplaySettings,
  });
}
